import angular from 'angular';


import OfficeInfo from '../info/';
import AddOfficeController from './addOfficeController';


export default angular.module('app.accounts.offices.addOffice', [OfficeInfo])
    .controller('AddOfficeController', AddOfficeController)
    .run(($templateCache) => {
        $templateCache.put('app/accounts/offices/addOffice/addOffice.html', require('./addOffice.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/addOffice/addContactInfo/addContactInfo.html', require('./addContactInfo/addContactInfo.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/addOffice/addOfficeInfo/addOfficeInfo.html', require('./addOfficeInfo/addOfficeInfo.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/addOffice/addOfficePaymentInfo/addOfficePaymentInfo.html', require('./addOfficePaymentInfo/addOfficePaymentInfo.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/addOffice/addOfficeProfile/addOfficeProfile.html', require('./addOfficeProfile/addOfficeProfile.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/accounts/offices/addOffice/index.js